import { lazy } from "react";
import { Navigate } from "react-router-dom";

import { routers } from "@/configs";

const Settings = lazy(() => import("@/pages/Profile/Settings"));
const Notifications = lazy(() => import("@/pages/Profile/Notifications"));
const Transactions = lazy(() => import("@/pages/Profile/Transactions"));
const MyBets = lazy(() => import("@/pages/Profile/MyBets"));

export const ProfileRoutes = [
  {
    path: routers.Notifications,
    element: <Notifications />,
  },
  {
    path: routers.Settings,
    element: <Navigate to={routers.SettingsAccount} replace />,
  },
  {
    path: routers.SettingsAccount,
    element: <Settings />,
  },
  {
    path: routers.SettingsSecurity,
    element: <Settings />,
  },
  {
    path: routers.SettingsVerify,
    element: <Settings />,
  },
  {
    path: routers.SettingsResponsibleGambling,
    element: <Settings />,
  },
  {
    path: routers.MyBetsCasino,
    element: <MyBets />,
  },
  {
    path: routers.Transactions,
    element: <Transactions />,
  },
];
